import { createSlice } from "@reduxjs/toolkit";

const initialState = {};

const reducers = {
  getScopedDataLakes(state, action) {
    const { scope, responses } = action.payload;
    state.__scopes ||= {};
    for (const key of Object.keys(state.__scopes)) {
      if (key.split(":")[0] !== scope.split(":")[0]) delete state.__scopes[key];
    }
    state.__scopes[scope] ||= {};
    for (const lake of responses) state.__scopes[scope][lake.getKey()] = lake;
  },
  getDataLakes(state, action) {
    const datalakes = action.payload;
    for (var lake of datalakes) {
      state[lake.getKey()] = lake;
    }
  },
};

export const slice = createSlice({
  name: "datalake",
  initialState,
  reducers,
});

export const { reducer } = slice;
